<template>
    <div class="pt-3 pb-5">
        <div class="row">
            <div class="col-12">
                <h3>Panel Administracyjny</h3>
                <hr>
            </div>
            <div class="col-4">
                <div class="card shadow">
                    <div class="card-body text-center">
                        <h5 class="card-title">Karty tarota</h5>
                        <p class="card-text font-weight-bold" v-if="data">{{data.tarot}}</p>
                        <router-link to="/home/cards-tarot" class="btn btn-sm btn-primary">Zarządzaj</router-link>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="card shadow">
                    <div class="card-body text-center">
                        <h5 class="card-title">Ciasteczka</h5>
                        <p class="card-text font-weight-bold" v-if="data">{{data.cookie}}</p>
                        <router-link to="/home/cookies" class="btn btn-sm btn-primary">Zarządzaj</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-12">
                <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalProfile">Edytuj dane konta</button>

                <div class="modal fade" id="modalProfile" tabindex="-1" aria-labelledby="modalProfileLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalProfileLabel">Edycja danych</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                            <form
                                @submit.prevent="submitForm($event, $data.form)"
                                action="/account/update"
                            >
                                <div class="form-group">
                                    <InputLabel
                                        label="Nowy adres email"
                                        name="email"
                                        type="email"
                                        v-model="form.email"
                                        @input="ev => form.email = ev"

                                        :invalid="validMessage ? (validMessage.email ? validMessage.email : null) : null"
                                    />
                                </div>
                                <div class="form-group mt-5">
                                    <InputLabel
                                        label="Hasło"
                                        name="current_password"
                                        type="password"
                                        v-model="form.current_password"
                                        @input="ev => form.current_password = ev"

                                        :invalid="validMessage ? (validMessage.current_password ? validMessage.current_password : null) : null"
                                    />
                                </div>
                                <div class="form-row">
                                    <div class="form-group col">
                                        <InputLabel
                                            label="Nowe hasło"
                                            name="new_password"
                                            type="password"
                                            autocomplete="new-password"
                                            v-model="form.new_password"
                                            @input="ev => form.new_password = ev"

                                            :invalid="validMessage ? (validMessage.new_password ? validMessage.new_password : null) : null"
                                        />
                                    </div>
                                    <div class="form-group col">
                                        <InputLabel
                                            label="Potwierdź hasło"
                                            name="new_confirm_password"
                                            type="password"
                                            autocomplete="new-password"
                                            v-model="form.new_confirm_password"
                                            @input="ev => form.new_confirm_password = ev"

                                            :invalid="validMessage ? (validMessage.new_confirm_password ? validMessage.new_confirm_password : null) : null"
                                        />
                                    </div>
                                </div>

                                <button type="submit" class="btn btn-primary">Zapisz</button>
                            </form>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InputLabel from '../../ui/InputLable';
    export default {
        data() {
            return {
                token: this.$parent._props.api_token,
                data: null,
                validMessage: null,
                form:
                {
                    current_password: null,
                    new_password: null,
                    new_confirm_password: null,
                    email: null,
                },
            }
        },
        methods: {
            fetchData(){
                let _this = this;
                this.$parent._data.loading = true;
                axios
                .get('/api/get-data', {
                    params:
                    {
                        'option': 'admin',
                    }
                }).then(response => {

                    this.data = response.data;

                    $('.loading').animate({
                        opacity: 0,
                    }, 1000, function(){
                        _this.$parent._data.loading = false;
                    })
                });
            },
            submitForm(ev, form){
                let serialize = $(ev.target).serialize();

                axios
                .post($(ev.target).attr('action'), form)
                .then(response => {

                    this.$parent._data.message.success = response.data.success;
                    this.$parent._data.message.content = response.data.content;

                    Object.keys(form).forEach(key => {
                        form[key] = null;

                    })
                })
                 .catch(error => {
                    if (error.response.status == 422){
                        this.validMessage = error.response.data.errors;
                    }
                })
            }
        },
        components: {
            InputLabel
        },
        mounted(){
            axios.defaults.params = {};
            axios.defaults.params['api_token'] = this.token;
            this.fetchData();
        },
    }
</script>
